/*
 * Purpose: User-facing product terminology — domains, brand, AutoBlocks Factory hierarchy
 * Last modified: 2026-06-27 | Agent
 * Completeness: 100
 */

/**
 * Domain split (autoblocks monorepo alignment):
 * - autoblocks.pro  — marketing site (legacy Render stack; DO IT handoff)
 * - autoblocks.run  — product app (this repository)
 *
 * AutoBlocks Factory contains the Block Generator, which produces Blocks.
 * AutoBlock Flow Composer assembles outcomes into a validated AutoBlock Flow (at rest).
 * Mission is the running map — START block required, GOAL block usual; MapLock optional.
 */
export const PRODUCT_DOMAINS = {
  /** Legacy marketing site — pricing, docs, DO IT hero */
  marketing: 'https://autoblocks.pro',
  /** Product app — compose, builder, execution (this repo) */
  app: 'https://autoblocks.run',
} as const;

/** App wordmark / browser title */
export const PRODUCT_NAME = 'Autoblocks.run' as const;

/** Short brand for prose, placeholders, and split-flap headlines */
export const PRODUCT_BRAND = 'Autoblocks' as const;

export const PRODUCT_TERMS = {
  productName: PRODUCT_NAME,
  productBrand: PRODUCT_BRAND,
  marketingSite: PRODUCT_DOMAINS.marketing,
  appSite: PRODUCT_DOMAINS.app,
  autoBlocksFactory: 'AutoBlocks Factory',
  blockGenerator: 'Block Generator',
  blockTypes: 'Block Types',
  contextualConfiguration: 'Contextual configuration',
  brandedBlockIdeas: 'Branded block ideas',
  blocks: 'Blocks',
  autoBlockFlow: 'AutoBlock Flow',
  autoBlockFlowComposer: 'AutoBlock Flow Composer',
  /** Running map (formerly Flow Map) — needs ≥1 block to start */
  mission: 'Mission',
  autoBlockFlowSetup: 'AutoBlock Flow Setup',
  onboardingWizard: 'Onboarding Wizard',
  /** @deprecated Use mission */
  autoBlockFlowMap: 'Mission',
} as const;

/** Factory pipeline: production of Blocks and the composed flow */
export const PRODUCT_PIPELINE = [
  PRODUCT_TERMS.autoBlocksFactory,
  PRODUCT_TERMS.blockGenerator,
  PRODUCT_TERMS.blocks,
  PRODUCT_TERMS.autoBlockFlow,
] as const;

export const PRODUCT_PIPELINE_LABEL = PRODUCT_PIPELINE.join(' → ');

/** Assembly + visualization */
export const PRODUCT_EXPERIENCE_LABEL = `${PRODUCT_TERMS.autoBlockFlowComposer} assembles · ${PRODUCT_TERMS.mission} runs`;
